export default "__VITE_ASSET__0af5e439__"